import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { useEffect, useState } from "react";
import "./alert-dialog.scss";
/* eslint-disable-next-line */
export interface AlertDialogProps {
  text: string;
  title: string;
  //   type: 'success' | 'error' | 'warning' | 'info' | 'pending';
  //   width?: 'full-width' | 'parent-width';
  //   timeClose?: number;
  handleShowExternaly?: boolean;
  show: boolean;
  setShow: (show: boolean) => void;
  actions: React.ReactElement;
  //   handlerOnClickTextLink?: () => void;
  //   textLink?: string;
  //   showButtonClose?: boolean;
}

export function AlertDialog({
  text,
  title,
  //   type,
  //   width = 'full-width',
  //   timeClose,
  show,
  setShow,
  handleShowExternaly,
  actions,
  //   textLink,
  //   handlerOnClickTextLink,
  //   showButtonClose = true,
}: AlertDialogProps) {
  const [hidde, setHidde] = useState(false);
  const close = () => {
    setHidde(true);
    if (window.history) {
      window.history.replaceState({}, document.title);
    }
    if (setShow) setShow(false);
  };
  useEffect(() => {
    if (handleShowExternaly) {
      if (show) {
        setHidde(false);
        // if (timeClose) {
        //   const timer = setTimeout(() => close(), timeClose);
        // }
      } else setHidde(true);
    }
  }, [show]);

  if (!hidde) {
    return (
      <Dialog
        open={show}
        onClose={() => setShow(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {text}
          </DialogContentText>
        </DialogContent>
        <DialogActions>{actions}</DialogActions>
      </Dialog>
      //   <div className={`alert-message alert-message_${type} ${width}`}>
      //     {(type == 'info' || type == 'pending') && <Info />}
      //     {(type == 'error' || type == 'warning') && <ReportProblem />}
      //     {type == 'success' && <CheckCircle />}
      //     <p>
      //       <span dangerouslySetInnerHTML={{ __html: text }} />
      //       {handlerOnClickTextLink && textLink && (
      //         <>
      //           <span onClick={handlerOnClickTextLink} className='text-link'>
      //             {textLink}
      //           </span>
      //           .
      //         </>
      //       )}
      //     </p>
      //     {showButtonClose && (
      //       <span className='btn close-button ' onClick={close}>
      //         <Close />
      //       </span>
      //     )}
      //   </div>
    );
  }
  return <></>;
}

export default AlertDialog;
